module.exports = __webpack_public_path__ + "img/blackboard-class2.36d6404a.svg";